import { assert_number_gte_0, assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO__generation_price_data extends DTO__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.GENERATION_PRICE_DATA;

  /*
   * FIELDS
   */

  field_hash__value_full!: string;
  price_credits!: number;
  //todo: mb use reservation_id
  //todo: mb use vps id hashed

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_not_empty(this.field_hash__value_full);
    assert_number_gte_0(this.price_credits);
  }
}
